import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CustomCSSLoader = ({ socketRef }) => {
  const [styles, setStyles] = useState([]);

  useEffect(() => {
    const fetchCSS = async () => {
      try {
        const res = await fetch(`${API_URL}/api/nightclub/custom-css`);
        if (res.ok) {
          const data = await res.json();
          setStyles(data);
        }
      } catch (e) { /* silent */ }
    };
    fetchCSS();
  }, []);

  // Listen for CSS updates via socket
  useEffect(() => {
    const socket = socketRef?.current;
    if (!socket) return;

    const handleCSSUpdate = (data) => {
      if (data.action === 'added') {
        setStyles(prev => {
          const filtered = prev.filter(s => s.css_id !== data.css_id);
          return [...filtered, { css_id: data.css_id, css: data.css, active: true }];
        });
      } else if (data.action === 'removed') {
        setStyles(prev => prev.filter(s => s.css_id !== data.css_id));
      }
    };

    socket.on('custom_css_updated', handleCSSUpdate);
    return () => socket.off('custom_css_updated', handleCSSUpdate);
  }, [socketRef]);

  return (
    <>
      {styles.filter(s => s.active).map((style) => (
        <style key={style.css_id} data-testid={`custom-css-${style.css_id}`}>
          {style.css}
        </style>
      ))}
    </>
  );
};

export default CustomCSSLoader;
